<template lang="pug">
  .decar_home
    vue-headful(
      :title="title"
    )
    .decar_home__menu
      el-row(:gutter="50" type="flex" justify="center")
        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          h2 Financial Assumptions
          el-radio-group(
            v-model="financialAssumptionsSwitch"
          )
            el-radio-button(label="Base Case")
            el-radio-button(label="Spot Case")
            el-radio-button(label="User Case")
          slider(
              :min="0"
              :step="0.10"
              :max="20"
              :custom-formatter="v => `${Math.round(v)} (US$/lb)`"
              v-model='financialInputs.nickelPrice'
              title='Nickel Price (US$/lb)'
              :baseValue='baseCaseFinancialAssumptions.nickelPrice'
              :hide='true'
              :precision="2"
          )
          slider(
              :min="10"
              :step="0.25"
              :max="20"
              :custom-formatter="v => `${Math.round(v)} (US$/oz)`"
              v-model='financialInputs.silverPrice'
              title='Silver Price'
              :baseValue='baseCaseFinancialAssumptions.silverPrice'
              :hide='true'
              :precision="2"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="0.15"
            :custom-formatter="v => `${Math.round(v*100)}%`"
            v-model='financialInputs.discountRate'
            title='Discount Rate'
            :hide='false'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0.65"
            :step="0.01"
            :max="1.65"
            :custom-formatter="v => `${v}`"
            v-model='financialInputs.CADUSD'
            title='FX Rate (CAD:USD)'
            :precision="2"
            :hide='false'
          )

          h2 Technical Assumptions
          el-radio-group(
            v-model="technicalAssumptionsSwitch"
          )
            el-radio-button(label="Base Case")
            el-radio-button(label="User Case")
          slider(
            :min="0"
            :step="0.00001"
            :max="0.0015"
            v-model='technicalInputs.millNickelGrade'
            title='Nickel Grade'
            :hide='true'
            :baseValue='baseCaseTechnicalAssumptions.millNickelGrade'
            :precision="5"
            type="percent"
            )
          slider(
            :min="0"
            :step="0.1"
            :max="5"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.millGoldGrade'
            title='Mill Gold Grade'
            :hide='true'
            :baseValue='baseCaseTechnicalAssumptions.millGoldGrade'
            :precision="2"
            type="percent"
          )
          slider(
              :min="0"
              :step="0.5"
              :max="20"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.heapLeachSilverGrade'
              title='Heap Leach Silver Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverGrade'
            :precision="2"
            type="percent"
          )
          slider(
              :min="0"
              :step="0.5"
              :max="100"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.millSilverGrade'
              title='Mill Silver Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.millSilverdGrade'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.heapLeachGoldRecovery'
            :hide='true'
            title='Heap Leach Gold Recovery'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachGoldRecovery'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.millGoldRecovery'
            :hide='true'
            title='Mill Gold Recovery'
            :baseValue='baseCaseTechnicalAssumptions.millGoldRecovery'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.millNickelRecovery'
            :hide='true'
            title='Mill Nickel Recovery'
            :baseValue='baseCaseTechnicalAssumptions.millNickelRecovery'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.nickelConcentrateGrade'
            :hide='true'
            title='Nickel Concentrate Grade'
            :baseValue='baseCaseTechnicalAssumptions.nickelConcentrateGrade'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.nickelPayability'
            :hide='true'
            title='Nickel Payability'
            :baseValue='baseCaseTechnicalAssumptions.nickelPayability'
            :precision="3"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.heapLeachSilverRecovery'
            :hide='true'
            title='Heap Leach Silver Recovery'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverRecovery'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.millSilverRecovery'
            :hide='true'
            title='Mill Silver Recovery'
            :baseValue='baseCaseTechnicalAssumptions.millSilverRecovery'
            :precision="2"
            type="percent"
          )
          slider(
            :min="0"
            :step="0.1"
            :max="10"
            :custom-formatter="v => `${v}x`"
            v-model='technicalInputs.stripRatio'
            :hide='true'
            title='Strip Ratio'
            :baseValue='baseCaseTechnicalAssumptions.stripRatio'
            :precision="3"
          )
          slider(
            :min="0"
            :step="0.05"
            :max="3"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.openPitMiningCostPerTonneMined'
            :hide='true'
            title='Open Pit Mining Cost per Tonne Mined (US$/t)'
            :baseValue='baseCaseTechnicalAssumptions.openPitMiningCostPerTonneMined'
            :precision="2"
          )
          slider(
            :min="0"
            :step="0.05"
            :max="4"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.heapLeachProcessCostPerTonneProcessed'
            :hide='true'
            title='Heap Leach Process Cost per Tonne Processed (US$/t)'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachCostPerTonneProcessed'
            :precision="2"
          )
          slider(
            :min="0"
            :step="0.25"
            :max="20"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.millProcessCostPerTonneProcessed'
            :hide='true'
            title='Mill Process Cost per Tonne Processed (US$/t)'
            :baseValue='baseCaseTechnicalAssumptions.millProcessCostPerTonneProcessed'
            :precision="2"
          )
          slider(
            :min="0"
            :step="0.05"
            :max="5"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.gAndACostPerTonneProcessed'
            :hide='true'
            title='G&A per Tonne Processed (US$/t)'
            :baseValue='baseCaseTechnicalAssumptions.gAndACostPerTonneProcessed'
            :precision="2"
          )
          slider(
            :min="-0.3"
            :step="0.05"
            :max="0.3"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.preProductionCapexVariance'
            :hide='false'
            title='Pre-Production Capex Variance'
            :precision="2"
            type="percent"
          )

        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          h2 Outputs
          el-row
            el-col(:lg="7" :md="7" :sm="7" :xs="7")
              el-radio-group(
                v-model="currencySwitch"
                size="large"
              )
                el-radio-button(label="USD")
                el-radio-button(label="CAD")
          .table
            el-table(
              v-loading="tableLoading"
              element-loading-text="Loading..."
              :data="tableData"
            )
              el-table-column(
                prop="field"
                width="150"
              )
              el-table-column(
                prop="units"
                label="Unit"
              )
              el-table-column(
                prop="baseCase"
                label="Base Case"
              )
              el-table-column(
                prop="spotCase"
                label="Spot Case"
              )
              el-table-column(
                prop="userCase"
                label="User Case"
              )

          .charts
              apexchart(
                width="100%"
                height="450"
                :options="productionChartOptions"
                :series="productionChartData"
              )
</template>

<script>
import modelApi from '@/services/ModelApi'
import _ from 'lodash'
import Slider from '@/components/slider'
import modelMixin from '../mixins/modelMixin'

export default {
  name: 'decar',
  components: { Slider },
  mixins: [modelMixin],
  data: function () {
    return {
      isOpen: 0,
      isOpenFinancial: 0,
      title: '',
      tableLoading: true,
      technicalInputs: {},
      financialInputs: {},
      // Switches
      financialAssumptionsSwitch: 'Base Case',
      technicalAssumptionsSwitch: 'Base Case',
      viewSwitch: 'Table',
      currencySwitch: 'USD',
      // API Outputs
      baseCase: {},
      userCase: {},
      spotCase: {},
      // Store assumptions for reseting
      baseCaseFinancialAssumptions: {},
      baseCaseTechnicalAssumptions: {},
      // Current Macro.  TODO: Get from an API.
      spotPrices: {
        discountRate: 0.08,
        delayStartYear: 0,
        nickelPrice: 6.28,
        CADUSD: 1 / 1.30
      },
      projectStage: 'Production',
      // Flag to build table after load
      loaded: false,
      tableData: [],
      // Information to create table
      aiscChartField: 'nickelC1Costs',
      fieldSettings: {
        'preTaxIrr': {
          'apiField': 'preTaxIrr',
          'unit': '%', // TODO: This should come from API
          'label': 'Pre-Tax IRR',
          'formatter': this.percent,
          'currency': false,
          'apiLocation': 'valuation'
        },
        'preTaxNpv': {
          'apiField': 'preTaxNpv',
          'unit': 'M', // TODO: This should come from API
          'label': 'Pre-Tax NPV',
          'formatter': this.millions,
          'currency': true,
          'apiLocation': 'valuation'
        },
        'irr': {
          'apiField': 'irr',
          'unit': '%', // TODO: This should come from API
          'label': 'After-Tax IRR',
          'formatter': this.percent,
          'currency': false,
          'apiLocation': 'valuation'
        },
        'npv': {
          'apiField': 'npv',
          'unit': 'M', // TODO: This should come from API
          'label': 'After-Tax NPV',
          'formatter': this.millions,
          'currency': true,
          'apiLocation': 'valuation'
        },
        'annualFreeCashFlow': {
          'apiField': 'freeCashFlow',
          'unit': 'M/year', // TODO: This should come from API
          'label': 'Free Cash Flow',
          'formatter': this.millions,
          'currency': true,
          'apiLocation': 'annual'
        },
        'C1Costs': {
          'apiField': 'nickelC1Costs',
          'unit': '/lb', // TODO: This should come from API
          'label': 'C1 Cost per lb',
          'formatter': this.number2,
          'currency': true,
          'apiLocation': 'lom'
        },
        'annualNickelProduction': {
          'apiField': 'nickelProduction',
          'unit': 'klbs/year', // TODO: This should come from API
          'label': 'Nickel Production',
          'formatter': this.number,
          'currency': false,
          'apiLocation': 'annual'
        }
      },
      currencyLabels: {
        'CAD': 'C$',
        'USD': 'US$'
      },
      exchangeRate: 1,
      activeTechnicalCollapse: []

    }
  },
  created () {
    this.debouncedUpdateData = _.debounce(this.updateData, 300)
    this.updateBase()
    this.updateSpot()
  },
  computed: {
    inputs () {
      let inputs = this.copy(Object.assign({}, this.technicalInputs, this.financialInputs))
      inputs['nickelPrice'] = inputs['nickelPrice'] * 2204.622
      return inputs
    },
    productionChartOptions () {
      // Dollar charts precede each value on y axis with a "$" sign.
      return {
        chart: {
          id: 'production-chart',
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ['#a8bfac', '#cedbb4', '#b8d9eb'],
        xaxis: {
          categories: this.userCase.years.labels,
          labels: {
            rotate: -45,
            rotateAlways: true
          }
        },
        yaxis: [
          {
            opposite: true,
            title: {
              text: 'C1 Costs ($/lb)',
              style: {
                fontSize: '16px'
              }
            },
            labels: {
              align: 'right',
              formatter: function (value) {
                return typeof value === 'number' ? '$ ' + value.toLocaleString() : value
              }
            }
          },
          {
            seriesName: 'Nickel Production',
            title: {
              text: 'Production per Year (klbs)',
              style: {
                fontSize: '16px'
              }
            },
            opposite: false,
            stacked: true,
            labels: {
              align: 'right',
              formatter: function (value) {
                return typeof value === 'number' ? value.toLocaleString() : value
              }
            }
          }
        ],
        stroke: {
          show: true,
          width: [3, 0, 0]
        },
        legend: {
          position: 'top'
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    productionChartData () {
      return [
        {
          name: 'C1 Cash Cost',
          type: 'line',
          data: Object.entries(this.userCase.years[this.aiscChartField]).map(([key, value]) => {
            return Math.round(value * this.exchangeRate * 100, 0) / 100 || 0
          })
        },
        {
          name: 'Nickel Production',
          type: 'column',
          data: Object.entries(this.userCase.years.nickelProduction).map(([key, value]) => {
            return Math.round(value, 0) || 0
          })
        }
      ]
    }
  },
  methods: {
    copy (object) {
      return JSON.parse(JSON.stringify(object))
    },
    millions (field, exchange) {
      let multiplier = 1
      if (exchange) {
        multiplier = this.exchangeRate
      }
      return Math.round(field * multiplier / 1000).toLocaleString()
    },
    number (field, exchange) {
      let multiplier = 1
      if (exchange) {
        multiplier = this.exchangeRate
      }
      return Math.round(field * multiplier).toLocaleString()
    },
    number2 (field, exchange) {
      let multiplier = 1
      if (exchange) {
        multiplier = this.exchangeRate
      }
      return (Math.round(field * multiplier * 100) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    percent (field, exchange) {
      let multiplier = 1
      if (exchange) {
        multiplier = this.exchangeRate
      }
      return Math.round(field * 100 * multiplier).toLocaleString() + '%'
    },
    round (number, decimals) {
      return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals)
    },
    tableRow (field) {
      let settings = this.fieldSettings[field]
      let units = '('
      if (settings.currency) {
        units = units + this.currencyLabels[this.currencySwitch] + ' '
      }
      units = units + settings.unit + ')'
      return {
        'field': settings.label,
        'units': units,
        'baseCase': settings.formatter(this.baseCase[settings.apiLocation][settings.apiField], settings.currency),
        'spotCase': settings.formatter(this.spotCase[settings.apiLocation][settings.apiField], settings.currency),
        'userCase': settings.formatter(this.userCase[settings.apiLocation][settings.apiField], settings.currency)
      }
    },
    updateBase () {
      this.updateData({ discountRate: 0.08 }, true)
    },
    updateSpot () {
      let params = this.copy(Object.assign({}, this.technicalInputs, this.spotPrices))
      params['nickelPrice'] = params['nickelPrice'] * 2204.622
      modelApi.fetchModel(
        params, 6
      ).then(response => {
        this.spotCase = response.data
      })
    },
    updateData (params, initialize) {
      modelApi.fetchModel(
        params, 6
      ).then(response => {
        this.userCase = response.data
        if (initialize) {
          this.baseCase = response.data
          this.technicalInputs = {
            'heapLeachGoldRecovery': response.data.lom.heapLeachGoldRecovery,
            'heapLeachSilverRecovery': response.data.lom.heapLeachSilverRecovery,
            'millGoldRecovery': response.data.lom.millGoldRecovery,
            'millSilverRecovery': response.data.lom.millSilverRecovery,
            'millNickelRecovery': response.data.lom.millNickelRecovery,
            'stripRatio': response.data.lom.stripRatio,
            'openPitMiningCostPerTonneMined': response.data.lom.openPitMiningCostPerTonneMined,
            'heapLeachProcessCostPerTonneProcessed': response.data.lom.heapLeachProcessCostPerTonneProcessed,
            'millProcessCostPerTonneProcessed': response.data.lom.millProcessCostPerTonneProcessed,
            'gAndACostPerTonneProcessed': response.data.lom.gAndACostPerTonneProcessed,
            'heapLeachGoldGrade': response.data.lom.heapLeachGoldGrade,
            'millGoldGrade': response.data.lom.millGoldGrade,
            'heapLeachSilverGrade': response.data.lom.heapLeachSilverGrade,
            'millSilverGrade': response.data.lom.millSilverGrade,
            'millNickelGrade': response.data.lom.millNickelGrade,
            'nickelConcentrateGrade': response.data.lom.nickelConcentrateGrade,
            'nickelPayability': response.data.lom.nickelPayability,
            'sustainingCapexVariance': 0,
            'preProductionCapexVariance': 0
          }
          this.financialInputs = {
            'discountRate': response.data.valuation.discountRate,
            'delayStartYear': response.data.valuation.delayStartYear,
            'nickelPrice': response.data.macro.nickelPrice / 2204.622,
            'CADUSD': this.dataOrSpot(response.data.macro.CADUSD) // TODO: make this more general
          }
          this.baseCaseFinancialAssumptions = this.copy(this.financialInputs)
          this.baseCaseTechnicalAssumptions = this.copy(this.technicalInputs)
          this.title = response.data.model.assetName
          this.loaded = true
        } else {
          this.buildTable()
        }
      })
    },
    buildTable () {
      this.tableData = [
        this.tableRow('irr'),
        this.tableRow('npv'),
        this.tableRow('annualFreeCashFlow'),
        this.tableRow('C1Costs'),
        this.tableRow('annualNickelProduction')
      ]
      this.tableLoading = false
    },
    dataOrSpot (data) {
      console.log(data)
      if (data === 0) {
        return this.spotPrices.CADUSD
      } else {
        return data
      }
    }
  },
  watch: {
    technicalInputs: {
      deep: true,
      handler () {
        if (this.loaded) {
          this.debouncedUpdateData(this.inputs, false)
        }
        if (JSON.stringify(this.technicalInputs) === JSON.stringify(this.baseCaseTechnicalAssumptions)) {
          this.technicalAssumptionsSwitch = 'Base Case'
        } else {
          this.technicalAssumptionsSwitch = 'User Case'
        }
      }
    },
    financialInputs: {
      deep: true,
      handler () {
        if (this.currencySwitch === 'CAD') {
          this.exchangeRate = 1 / this.financialInputs.CADUSD
        }
        if (this.loaded) {
          this.debouncedUpdateData(this.inputs, false)
        }
        if (JSON.stringify(this.financialInputs) === JSON.stringify(this.baseCaseFinancialAssumptions)) {
          this.financialAssumptionsSwitch = 'Base Case'
        } else if (JSON.stringify(this.financialInputs) === JSON.stringify(this.spotPrices)) {
          this.financialAssumptionsSwitch = 'Spot Case'
        } else {
          this.financialAssumptionsSwitch = 'User Case'
        }
      }
    },
    currencySwitch (value) {
      if (value === 'CAD') {
        this.exchangeRate = 1 / this.financialInputs.CADUSD
      } else {
        this.exchangeRate = 1
      }
      this.buildTable()
    },
    technicalAssumptionsSwitch (value) {
      if (value === 'Base Case') {
        this.technicalInputs = this.copy(this.baseCaseTechnicalAssumptions)
      }
    },
    financialAssumptionsSwitch (value) {
      if (value === 'Base Case') {
        this.financialInputs = this.copy(this.baseCaseFinancialAssumptions)
      } else if (value === 'Spot Case') {
        // TODO: Make more general.  Is there a way to update the dictionary?
        this.financialInputs.CADUSD = this.spotPrices.CADUSD
        this.financialInputs.nickelPrice = this.spotPrices.nickelPrice
      }
    },
    loaded () {
      if (this.loaded) {
        this.buildTable()
      }
    }
  }
}
</script>

<style scoped>
.tooltip {
  font-family: sans-serif;
}

.decar_home {
  background: white;
}

.decar_home .el-table {
  font-size: 15px !important;
}

.decar_home p {
  margin-top: 1px !important;
  margin-bottom: 0 !important;
}

.decar_home h1 {
  font-size: 40px;
  margin-bottom: 0;
}

.decar_home h2 {
  font-size: 21px;
  font-weight: bold;
  margin-top: 17.4px !important;
  margin-bottom: 17.4px !important;
}

.decar_home h3 {
  font-size: 20px;
}

.decar_home h4 {
  color: #555;
  font-weight: 100;
  font-size: 21px;
  margin-top: 6px;
}

.decar_home__menu {
  font-size: 13px;
  line-height: 16px;
  background-color: white;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.03);
  z-index: 12;
}

.decar_home__menu p,
.decar_home__menu b {
  margin: 0;
}

.decar_home__menu b {
  float: right;
}

.decar_home .el-radio-group {
  margin-bottom: 10px;
  margin-right: 5px;
}

.charts {
  margin-top: 25px;
}

@media screen and (max-width: 1366px) {
  .tooltip {
    display: none;
  }
}
</style>
